import React from "react";
const SvgDsApple = props => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="#fff"
      d="M15.627 1.5c.073 2.66-1.829 4.504-3.728 4.388-.313-2.122 1.9-4.388 3.728-4.388zM3.7 12.312c0 3.095 2.462 9.17 5.439 9.188h.02c.74 0 1.392-.244 1.968-.459l.005-.002c.423-.158.822-.307 1.138-.307.623 0 1 .16 1.438.346.432.183.922.392 1.614.392 2.832 0 4.782-5.247 4.782-5.491 0-.374-.284-.545-.56-.71v-.001c-.626-.377-1.926-1.159-1.926-3.19 0-1.716 1.148-2.583 1.777-3.058l.441-.332-.306-.46c-1.307-1.963-3.48-2.12-4.198-2.12h-.005c-.96 0-1.785.328-2.448.591l-.013.006c-.307.121-.652.258-.799.258-.25 0-.698-.165-1.132-.325-.62-.229-1.323-.487-1.982-.487-1.461 0-5.253 1.106-5.253 6.161z"
    />
  </svg>
);
export default SvgDsApple;
